import { FC } from 'react';
import { Tab } from '@scale/scaleui';
import { ChatTaskAudit } from '../../ChatTaskAudit';

export const TaskAudit: FC = () => (
  <Tab.Panel>
    <div className="flex w-full justify-center my-4 bg-neutral-0">
      <ChatTaskAudit />
    </div>
  </Tab.Panel>
);
